import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Amit Mehta </span>
            from <span className="purple">Jharkhand,India.</span>
            <br />I am a fresher, pursuing Full-Stack Web Development at Masai School
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Writing poetry
            </li>
           
            <li className="about-activity">
              <ImPointRight /> Listening Music
            </li>
          </ul>

          <p style={{ marginBlockEnd: 0, color: "rgb(155 126 172)" }}>
            "Love the way to solve real world problems using snnipet of code!"{" "}
          </p>
          <footer className="blockquote-footer">Amit</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
